import { Box } from "@material-ui/core"
import { GenericInput } from "components/GenericInput/GenericInput"
import { useFormikContext } from "formik"
import styled from "styled-components"
import { usePurchaseContext } from "./PurchaseContext"
import HeadingText from "./Texts/HeadingText"

const StyledBox = styled(Box)<{ $selectedMode: string }>`
  margin-top: 30px;
  .MuiFormHelperText-root {
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 60px;

    h4 {
      margin-right: ${(p) => (p.$selectedMode === "full" ? "150px" : "0px")};
    }
  }
`

const StyledFieldWrapper = styled(Box)<{ $selectedMode: string }>`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-wrap: wrap;
    width: 450px;
    gap: 20px 0;
    justify-content: "flex-start";
    .MuiFormControl-root {
      width: 200px !important;
      margin-left: 10px;
      :nth-child(2n) {
        margin-left: 0;
      }
    }
    margin-right: ${(p) => (p.$selectedMode === "full" ? "150px" : "0px")};
  }
`

const StyledError = styled.p`
  margin: 0;
  padding: 0;
  text-align: right;
  color: #d70202;
  font-size: 20px;
  width: 100%;
  line-height: 1;
  margin-top: 5px;
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 200px;
  }
`

const StyledFormInput = styled(GenericInput)<{ $unicodeBidi: string }>`
  input {
    unicode-bidi: ${(p) => p.$unicodeBidi};
    text-align: right;
  }

  margin-top: 10px;
`

const StyledPersonalFormInput = styled(GenericInput)`
  margin-top: 10px;
`

const StyledInputWrapper = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    > * {
      width: 100%;
    }
  }
`

type PersonalFieldsProps = {
  selectedMode: string
  formatPhoneNumber: (value: string) => string
  regex: RegExp
}

const MyPersonalFields = ({
  selectedMode,
  formatPhoneNumber,
}: PersonalFieldsProps) => {
  const { setFieldValue, values } = useFormikContext<any>()
  const { blessingMode } = usePurchaseContext()

  const handlePhoneInput = (evt, valueName: string) => {
    //only allow numbers without '-' symbol
    if (evt.target.value.length) {
      const formattedValue = formatPhoneNumber(evt.target.value)
      setTimeout(() => {
        setFieldValue(valueName, formattedValue)
      }, 0)
    }
  }

  return (
    <StyledBox $selectedMode={selectedMode} tabIndex={0}>
      <HeadingText
        text="הפרטים שלי"
        tabIndex={0}
        textIndent={blessingMode !== "short"}
        marginBottom={20}
      />

      <StyledFieldWrapper $selectedMode={selectedMode}>
        <StyledInputWrapper>
          <StyledPersonalFormInput
            name="senderName"
            label="שם פרטי (*חובה)"
            type="text"
            maxLength={30}
            $width="200px"
            $mobileWidth="100%"
            autoComplete="given-name"
            topMargin="0"
          />
          {values.senderName.length > 30 && (
            <StyledError>ניתן להזין עד 30 תווים</StyledError>
          )}
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledPersonalFormInput
            name="senderLastName"
            label="שם משפחה (*חובה)"
            type="text"
            maxLength={30}
            $width="200px"
            $mobileWidth="100%"
            autoComplete="family-name"
            topMargin="0"
          />
          {values.senderLastName.length > 30 && (
            <StyledError>ניתן להזין עד 30 תווים</StyledError>
          )}
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledPersonalFormInput
            name="senderMobilePhone"
            label="(חובה*) טלפון"
            type="tel"
            $width="200px"
            $mobileWidth="100%"
            numeric={true}
            onInput={(e) => handlePhoneInput(e, "senderMobilePhone")}
            onPaste={async (e) => {
              const clipboardData = e.clipboardData.getData("Text")
              e.clipboardData.clearData()
              setTimeout(async () => {
                const phone = formatPhoneNumber(clipboardData)
                setFieldValue("senderMobilePhone", phone)
              }, 300)
            }}
            autoComplete="tel"
            topMargin="0"
          />
        </StyledInputWrapper>
        <StyledInputWrapper>
          <StyledFormInput
            name="senderEmail"
            label="אימייל (*חובה)"
            type="text"
            $width="200px"
            $mobileWidth="100%"
            autoComplete="email"
            inputMode="email"
            $unicodeBidi={
              values.senderEmail.match(/[a-zA-Z]/) ? "plaintext" : "normal"
            }
            topMargin="0"
          />
        </StyledInputWrapper>
      </StyledFieldWrapper>
    </StyledBox>
  )
}

export default MyPersonalFields
